<template>
  <div id="app">    
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {
    console.log(this.$router);
  },
  methods: {
    
  }
}
</script>

<style>
* {
  margin: 0;
}
body {
  background: #F6F6F6;
}

#app {
  padding-top: 54px;
}
.flexView {
  display: flex;
  align-items: center;
}

.canClick {
  cursor: pointer;
}
.maxWidth {
  width: 1400px;
  margin: 0 auto;
}
.minWidth {
  width: 880px;
  margin: 0 auto;
  padding: 10px 0;
}

.el-card__body {
  padding: 20px 30px;
}
.el-button--primary {
  background: #39A4DC !important;
  border-color: #39A4DC !important;
}
.grayFont6 {
  color: #666;
}
.grayFont9 {
  color: #999;
}
.redBg {
  background: #D54B53;
}
.redFont2 {
  color: #D54B53;
}

.el-card {
  box-shadow: none !important;
}

</style>
